import {ActionsRow, DetailLeftIcon, FixedDropDownButton, i18n, Icon} from 'mc/lib';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {CardBlock, Col, DropdownItem, Row} from 'reactstrap';
import {TypUcelIcon} from '../druhucel';
import './Lokalita.scss';

export default class Lokalita extends PureComponent {

    static propTypes = {
        lokalita: PropTypes.object.isRequired,
        onEdit: PropTypes.func,
        onDelete: PropTypes.func,
    };

    handleEdit = () => {
        const {lokalita, onEdit} = this.props;
        onEdit(lokalita);
    };

    handleDelete = () => {
        const {lokalita, onDelete} = this.props;
        onDelete(lokalita);
    };

    renderActions() {
        const {onEdit, onDelete} = this.props;
        if (!onEdit && !onDelete) {
            return null;
        }
        return (
            <FixedDropDownButton noCaret color="action action-hover" title={<Icon icon="ellipsis-v"/>}>
                {onEdit && <DropdownItem onClick={this.handleEdit}>{i18n('global.update')}</DropdownItem>}
                {onDelete && <DropdownItem onClick={this.handleDelete}>{i18n('global.delete')}</DropdownItem>}
            </FixedDropDownButton>
        );
    }

    render() {
        const {lokalita} = this.props;
        const {druhUcel, identifikace, definice, popisObdobi, popisUcel} = lokalita;

        return (
            <CardBlock>
                <ActionsRow actions={this.renderActions()} noCenter>
                    <DetailLeftIcon icon={<TypUcelIcon typUcel={druhUcel.typUcel}/>}>
                        <Row>
                            <Col className="lokalita-definice" xs={12} onClick={this.handleEdit}>
                                <a className="row-header text-truncate" href="#">{definice || identifikace}</a>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="text-truncate">
                                <span className="text-brand-secondary">{popisObdobi}</span>
                            </Col>
                            <Col className="col-auto">
                                {druhUcel.nazev}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} className="text-truncate">
                                {popisUcel}
                            </Col>
                        </Row>
                    </DetailLeftIcon>
                </ActionsRow>
            </CardBlock>
        );
    }
}
